import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('map');

    return {
        BOUNDARY: t('boundary'),
        INCOMPLETE_BOUNDARY: t('incompleteBoundary'),
        NO_APPLY: t('noApply'),
        NO_ENTRY: t('noEntry')
    };
};

export default useTranslation;
